
import i18n from "@/i18n";
import { Vue } from "vue-class-component";

export default class App extends Vue {
  i18nConst = i18n;
}
